import { axiosFetch } from './fetchFactory';

// const initiatePwdUrl = `/model/controllers/public/contact-us.cfc?method=process`;

type ContactUsForm = {
    fullName: string,
    email: string,
    phone: string,
    company: string,
    message: string,
    reCaptcha: string    
}

export default (data: ContactUsForm): Promise<{ success?: string, error?: string }> => {

    return axiosFetch().post(`/model/controllers/public/contact-us.cfc?method=process`, data)
        .then(res => res.data)
        .catch( res => ({error: 'failed to update'}) );

    // return fetch(initiatePwdUrl, {
    //     method: 'POST',
    //     credentials: 'same-origin',
    //     cache: 'no-store',
    //     headers: new Headers({'Content-Type': 'application/json'}),
    //     body: JSON.stringify(data)
    // })
    // .then(res => res.json())
    // .catch( res => ({error: 'failed to update'}) );
};